import React from 'react';

export interface ScoreHeaderProps {
  title: string;
  subtitle: string;
  // Etiqueta de data mostrada no chip a direita (ja formatada).
  dateLabel?: React.ReactNode;
}

// Cabecalho partilhado dos Insights (titulo + subtitulo + chip de data),
// partilhado entre Lite e Pro para deixarem de duplicar este bloco (PL-005).
const ScoreHeader: React.FC<ScoreHeaderProps> = ({ title, subtitle, dateLabel }) => (
  <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
    <div>
      <h2 className="text-2xl font-bold text-slate-800 md:text-3xl">{title}</h2>
      <p className="mt-1 max-w-3xl text-sm text-slate-600 md:text-base">{subtitle}</p>
    </div>
    {dateLabel !== undefined && (
      <div className="rounded-md border border-stone-200 bg-white px-3 py-2 text-sm text-slate-700 shadow-sm">
        <span className="font-medium">{dateLabel}</span>
      </div>
    )}
  </div>
);

export default ScoreHeader;
